// extracted by mini-css-extract-plugin
export default {"createDatasetSection":"style_createDatasetSection__zy7Pm","tilesContainer":"style_tilesContainer__KxhGP"};